"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var PdpSelectedVariantIndex = function (_a) {
    var variant = _a.variant, product = _a.product;
    var initializeSelectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.initialize; });
    (0, react_1.useEffect)(function () {
        var priceDollars = (0, currency_js_1.default)(variant.price, { fromCents: true }).value;
        (0, react_dom_1.unstable_batchedUpdates)(function () {
            initializeSelectedVariant({ initialVariant: __assign(__assign({}, variant), { price: priceDollars, product: { tags: product.tags, title: product.title } }), emitViewItemEventToGa: true });
        });
    }, [initializeSelectedVariant, variant, product.tags, product.title]);
    return null;
};
(0, render_app_1.default)('data-pdp-selected-variant-app', function (el) {
    var datasetVariant = el.dataset.variant;
    var datasetProduct = el.dataset.product;
    if (!datasetVariant)
        throw new Error('Missing pdp-selected-variant data-variant');
    if (!datasetProduct)
        throw new Error('Missing pdp-selected-variant data-product');
    var variant = JSON.parse(datasetVariant);
    var product = JSON.parse(datasetProduct);
    return react_1.default.createElement(PdpSelectedVariantIndex, { variant: variant, product: product });
});
